module.exports = __webpack_public_path__ + "static/de_auto_premium.cc04c96c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/de_auto_premium.png
// module id = 405
// module chunks = 35783957827783